<div
  class="range-slider-dropdown"
  [class.range-slider-dropdown--open]="isDropdownOpen"
  [class.range-slider-dropdown--has-value]="
    currentOption.value !== defaultOption?.value
  "
>
  <button
    class="range-slider-dropdown__button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="toggleDropdown()"
  >
    <span class="range-slider-dropdown__button-text">
      <span class="range-slider-dropdown__button-value">
        {{ currentOption?.text }}
      </span>
      <span class="range-slider-dropdown__button-unit">
        <ng-container *ngTemplateOutlet="unitTemplate"></ng-container>
      </span>
    </span>
    <i
      class="range-slider-dropdown__button-arrow material-icon material-icon--outlined"
    >
      arrow_drop_down
    </i>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayLockPosition]="true"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    (overlayOutsideClick)="close()"
    (detach)="close()"
  >
    <lib-dropdown-menu
      [options]="options"
      [currentOption]="currentOption"
      [highlightSelected]="true"
      (update)="select($event)"
      (tabOut)="close()"
    ></lib-dropdown-menu>
  </ng-template>
</div>
